module.exports = __webpack_public_path__ + "media/img/vca/prizes/conspicuousscents-6d11243b2183b270ac2c63b791f62da9.png";